<div class="row" [nbSpinner]="loading" nbSpinnerStatus="info">
  <div
    class="col-12"
    *ngIf="newComment && (userService.$isAuthenticated | async)"
  >
    <nb-card>
      <nb-card-body>
        <form [formGroup]="replyForm">
          <div *ngIf="reply.toUid && reply.level > 0" class="form-group">
            <ngx-view-user-display
              [user]="reply.toAuthor"
              [mode]="'name'"
              [icon]="'at-outline'"
            >
            </ngx-view-user-display>

            <span class="ref-title"
              >: "{{
                reply.refTitle.length < 60
                  ? reply.refTitle
                  : reply.refTitle.substring(0, 60) + "..."
              }}"
            </span>
          </div>
          <div class="form-group">
            <textarea
              nbInput
              fullWidth
              class="form-control"
              rows="3"
              placeholder="Aa"
              formControlName="content"
              [(ngModel)]="reply.content"
            ></textarea>
          </div>
        </form>
      </nb-card-body>
      <nb-card-footer>
        <button
          type="submit"
          nbButton
          shape="semi-round"
          status="primary"
          size="small"
          [disabled]="submitted || !replyForm.valid"
          [class.btn-pulse]="submitted"
          (click)="createReply()"
        >
          Gửi
        </button>
      </nb-card-footer>
    </nb-card>
  </div>

  <div *ngFor="let item of comments; let i = index" class="col-12">
    <nb-card [nbSpinner]="item.loading" nbSpinnerStatus="info">
      <nb-card-header>
        <div class="summary">
          <div class="item">
            <div class="avatar">
              <ngx-view-user-display
                [user]="item.author"
                [mode]="'avatar'"
              ></ngx-view-user-display>
            </div>

            <div class="content">
              <div class="content-header">
                <div>
                  <ngx-view-user-display
                    [user]="item.author"
                    [mode]="'name'"
                  ></ngx-view-user-display>
                  <ngx-view-time-ago
                    [currentDate]="item.createdOn"
                  ></ngx-view-time-ago>
                </div>

                <div class="button-action">
                  <button
                    *ngIf="!item.editing && item.createdBy === uid"
                    nbButton
                    ghost
                    size="small"
                    [disabled]="submitted"
                    [class.btn-pulse]="submitted"
                    (click)="deleteReply(item)"
                  >
                    <nb-icon icon="trash-2-outline"></nb-icon>
                  </button>

                  <button
                    *ngIf="
                      item.createdBy === uid &&
                      !item.editing &&
                      mode !== 'student'
                    "
                    nbButton
                    ghost
                    size="small"
                    [disabled]="submitted"
                    [class.btn-pulse]="submitted"
                    (click)="onEditReply(item)"
                  >
                    <nb-icon icon="edit-2-outline"></nb-icon>
                  </button>
                </div>
              </div>

              <div *ngIf="item.toUid && item.level > 0" class="text-hint">
                <ngx-view-user-display
                  [user]="item.toAuthor"
                  [mode]="'name'"
                  [icon]="'at-outline'"
                >
                </ngx-view-user-display>

                <span *ngIf="!item.moreRefTitle" class="ref-title"
                  >: "{{
                    item.refTitle.length < 60
                      ? item.refTitle
                      : item.refTitle.substring(0, 60) + "..."
                  }}"
                </span>
                <span *ngIf="item.moreRefTitle" class="ref-title"
                  >: "{{ item.refTitle }}"
                </span>

                <a
                  *ngIf="item.refTitle && item.refTitle.length >= 60"
                  (click)="readMoreRefTitle(item)"
                  class="link"
                >
                  <nb-icon
                    status="info"
                    [icon]="
                      item.moreRefTitle ? 'chevron-left' : 'chevron-right'
                    "
                  ></nb-icon>
                </a>
              </div>

              <div *ngIf="!item.editing" class="view-content">
                <p style="white-space: pre-line">{{ item.content }}</p>
              </div>

              <div *ngIf="item.editing" class="view-content">
                <textarea
                  nbInput
                  fullWidth
                  class="form-control"
                  rows="3"
                  placeholder="Nhập bình luận"
                  [(ngModel)]="content"
                ></textarea>

                <div class="button-actions">
                  <button
                    type="submit"
                    nbButton
                    fullWidth
                    outline
                    shape="semi-round"
                    status="primary"
                    size="small"
                    [disabled]="submitted || content.length <= 0"
                    [class.btn-pulse]="submitted"
                    (click)="editReply(item)"
                  >
                    Lưu
                  </button>

                  <button
                    type="submit"
                    nbButton
                    fullWidth
                    outline
                    shape="semi-round"
                    size="small"
                    [disabled]="submitted"
                    [class.btn-pulse]="submitted"
                    (click)="cancelReply(item)"
                  >
                    Hủy
                  </button>
                </div>
              </div>

              <div *ngIf="!item.editing" class="button-actions">
                <ngx-view-like *ngIf="mode != 'student'" [comment]="item">
                </ngx-view-like>

                <button
                  nbButton
                  ghost
                  status="info"
                  size="small"
                  (click)="onNewReply(item)"
                >
                  <nb-icon icon="message-square-outline"></nb-icon>

                  Trả lời
                </button>

                <ngx-button-report-spam
                  [comment]="item"
                  (onReport)="report($event)"
                ></ngx-button-report-spam>
              </div>
            </div>
          </div>
        </div>
      </nb-card-header>
    </nb-card>
  </div>

  <div class="col-12" *ngIf="loading">
    <ngx-view-placeholder></ngx-view-placeholder>
  </div>

  <div class="col-12">
    <nb-actions size="small" class="see-more-button">
      <nb-action (click)="onNewReply(null)">
        <nb-icon class="action-icon" icon="message-square-outline"></nb-icon>
        <span *ngIf="mode !== 'student'" class="text-link"> Bình luận </span>
        <span *ngIf="mode === 'student'" class="text-link"> Nhắn tin </span>
      </nb-action>

      <nb-action *ngIf="!done" (click)="loadMore()">
        <nb-icon class="action-icon" icon="more-horizontal-outline"></nb-icon>
        <span class="text-link">Xem thêm</span>
      </nb-action>

      <nb-action (click)="closeReplies()">
        <nb-icon class="action-icon" icon="chevron-up-outline"></nb-icon>
        <span class="text-link">Thu gọn</span>
      </nb-action>
    </nb-actions>
  </div>
</div>
